export const getNotificationComponent = (definition, showGrouped) => {
  if (showGrouped) {
    return definition?.grouped;
  }
  return definition?.single || definition;
};

export const processSubmissionsGroup = (group, isRevision) => {
  const notifsByProject = [];
  const countKey = isRevision ? "revision_count" : "entry_count";
  group.forEach((notification) => {
    const projectNotif = notifsByProject.find(
      (n) => n.context?.project?.id === notification.context?.project?.id
    );
    if (projectNotif) {
      projectNotif.uuid.push(notification.uuid);
      projectNotif.context.creative_ids.add(notification.context?.creative?.id);
      projectNotif.context[countKey] += 1;
      projectNotif.showGrouped = true;
    } else {
      notifsByProject.push({
        ...notification,
        uuid: [notification.uuid],
        context: {
          ...notification.context,
          creative_ids: new Set([notification.context?.creative?.id]),
          [countKey]: 1,
        },
      });
    }
  });
  return notifsByProject;
};

export const processPresentationFeedbackGroup = (group) => {
  const notifsByPresentation = [];
  group.forEach((notification) => {
    const presentationNotif = notifsByPresentation.find(
      (n) =>
        n.context?.presentation?.id === notification.context?.presentation?.id
    );
    if (presentationNotif) {
      presentationNotif.uuid.push(notification.uuid);
    } else {
      notifsByPresentation.push({
        ...notification,
        showGrouped: true,
        uuid: [notification.uuid],
      });
    }
  });
  return notifsByPresentation;
};

export const processFGVoteReceivedGroup = (group) => {
  const notifsByFocusGroup = [];
  group.forEach((notification) => {
    const focusGroupNotif = notifsByFocusGroup.find(
      (n) =>
        n.context?.focus_group?.id === notification.context?.focus_group?.id
    );
    if (focusGroupNotif) {
      focusGroupNotif.uuid.push(notification.uuid);
      focusGroupNotif.context.vote_count += 1;
      focusGroupNotif.showGrouped = true;
    } else {
      notifsByFocusGroup.push({
        ...notification,
        uuid: [notification.uuid],
        context: {
          ...notification.context,
          vote_count: 1,
        },
      });
    }
  });
  return notifsByFocusGroup;
};
